export default "__VITE_ASSET__ZH1R0VKw__";